/* eslint-disable */
export var Direction;
(function (Direction) {
  Direction.Right = 'to right';
  Direction.Left = 'to left';
  Direction.Down = 'to bottom';
  Direction.Up = 'to top';
}(Direction || (Direction = {})));
